// File: src/components/about/Research.js

import React from 'react';
import styles from './Research.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

const PARTNERS = [
  {
    id: 'tmu',
    institution: 'Toronto Metropolitan University',
    department: 'Aerospace Engineering Department',
    lead: 'Dr. Krishna Kumar',
    leadRole: 'Lead Researcher',
    description:
      'Our collaboration with TMU\'s Aerospace Engineering Department brings NASA-derived sensor and telemetry technology into the organic waste processing space — enabling the real-time, 24/7 remote monitoring that sets the GS Digester apart from every competing system.',
    tags: ['Telemetry', 'Sensor Systems', 'Remote Monitoring'],
  },
  {
    id: 'aafc',
    institution: 'Agriculture & Agri-Food Canada',
    department: 'Summerland Research & Development Centre',
    lead: 'Dr. Mehdi Sharifi',
    leadRole: 'Soil Fertility Expert',
    description:
      'Working with Agriculture and Agri-Food Canada\'s Okanagan Valley research centre, we validate the agronomic performance of our worm castings — ensuring every batch meets the highest standards for soil fertility, nutrient availability, and long-term soil health.',
    tags: ['Soil Science', 'Worm Castings', 'Agronomy'],
  },
];

function Research() {
  return (
    <section className={styles.section}>
      <div className="site-container">

        {/* Header */}
        <ScrollAnimation className={styles.header}>
          <p className={styles.eyebrow}>Research & Partnerships</p>
          <h2 className={styles.heading}>
            Grounded in Academic Excellence
          </h2>
          <p className={styles.subheading}>
            Our technology is validated by leading Canadian research institutions
            spanning soil science, permaculture, aerospace engineering, and
            industrial design.
          </p>
        </ScrollAnimation>

        {/* Partner cards */}
        <div className={styles.grid}>
          {PARTNERS.map((partner, i) => (
            <ScrollAnimation key={partner.id} delay={i * 150} className={styles.cardWrap}>
              <div className={styles.card}>

                {/* Top bar */}
                <div className={styles.cardTop}>
                  <p className={styles.institution}>{partner.institution}</p>
                  <p className={styles.department}>{partner.department}</p>
                </div>

                {/* Body */}
                <p className={styles.description}>{partner.description}</p>

                {/* Tags */}
                <div className={styles.tags}>
                  {partner.tags.map((tag) => (
                    <span key={tag} className={styles.tag}>{tag}</span>
                  ))}
                </div>

                {/* Lead researcher */}
                <div className={styles.lead}>
                  <div className={styles.leadDot} />
                  <div>
                    <span className={styles.leadName}>{partner.lead}</span>
                    <span className={styles.leadRole}>{partner.leadRole}</span>
                  </div>
                </div>

              </div>
            </ScrollAnimation>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Research;